import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import './App.css';

class App extends Component {
  render() {
    window.parent.postMessage(JSON.stringify({
      action: "updateHeight",
      height: 650,
    }), "*");

    return (
      <div className="sid-program-container">
        <VerificationForm programId="5d7fae67e05b561ffb8e86a7" />
      </div>
    );
  }
}

export default App;
